import { API_CONFIG, API_ENDPOINTS, getHeaders, apiCall } from './client';
import { NewUserDefaultRole, NewUserPolicyResponse } from '../../types';

// =============================================================================
// Org Security — New-User Access Policy
// =============================================================================
// Customer-facing, MANAGE_ORG-gated endpoints on guides_knowledge_graph that
// control what a brand-new user automatically receives the first time they
// sign in to the org. Mirrors the org-level roles client (rbac.ts) — NOT the
// Adobe-admin Command Center client (commandCenter.ts).

/**
 * Fetch the org's current new-user access policy.
 * GET /flameback/api/v1/orgs/{orgId}/security/new-user-policy
 */
export async function fetchNewUserPolicy(orgId: string): Promise<NewUserPolicyResponse> {
  return apiCall<NewUserPolicyResponse>(
    `${API_CONFIG.BASE_URL}${API_ENDPOINTS.ORG_NEW_USER_POLICY(orgId)}`,
    {
      method: 'GET',
      headers: getHeaders(),
    },
  );
}

/**
 * Update the org's new-user access policy and return the stored value.
 * PUT /flameback/api/v1/orgs/{orgId}/security/new-user-policy
 */
export async function updateNewUserPolicy(
  orgId: string,
  value: NewUserDefaultRole,
): Promise<NewUserPolicyResponse> {
  return apiCall<NewUserPolicyResponse>(
    `${API_CONFIG.BASE_URL}${API_ENDPOINTS.ORG_NEW_USER_POLICY(orgId)}`,
    {
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify({ new_user_default_role: value }),
    },
  );
}
